import {DocumentNode, useQuery} from "@apollo/client";
import {TypedQueryDocumentNode} from "graphql";


export default ({query,variables,children}:{query:DocumentNode|TypedQueryDocumentNode,variables?:any,children:(data:any)=>any})=>
{
    const {data,loading,error} = useQuery(query,{variables})
    if(loading)
    {
        return "Loading..";
    }
    else if(error)
    {
        return <p style={{color:"red"}}>
            Encountered an error {query.kind}.
            {error.message}
            </p>
    }
    else
    {
        return children(data);
    }


}
